/**
 * Контракт GET /v1/me (internal/me/interfaces/http/handlers.go).
 *
 * Бэкенд отдаёт минимальный профиль: { id, email, display_name, tenant_slug,
 * roles }. Телефон/должность/язык/тимзона/Telegram/уведомления бэкенд пока
 * НЕ хранит — на экране «Профиль» (§2.2) они показываются read-only/заглушкой
 * (без фейк-сабмита), пока не появятся на бэке.
 */
import { customFetch } from '@hsc/api-client';

export interface MeResponse {
  id: string;
  email: string;
  display_name?: string;
  /** UUID тенанта из JWT — нужен формам создания номера/типа номера (бэк
   *  CreateRoom/CreateRoomType требует tenant_id в теле запроса). */
  tenant_id?: string;
  tenant_slug?: string;
  roles: string[];
  /** Гостевые поля (роль guest, активный грант): фамилия + номер комнаты из
   *  гранта, tg_bound — привязан ли Telegram. У персонала отсутствуют. */
  surname?: string;
  room_number?: string;
  tg_bound?: boolean;
}

/** GET /v1/me — профиль текущего пользователя. */
export async function fetchMe(): Promise<MeResponse> {
  return customFetch<MeResponse>({ url: '/me', method: 'GET', baseURL: '/v1' });
}
